import { render, staticRenderFns } from "./DocumentApprovalStatus.vue?vue&type=template&id=d39206a2"
import script from "./DocumentApprovalStatus.vue?vue&type=script&lang=js"
export * from "./DocumentApprovalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports